<template>
  <div>
    <el-table
      :border="true"
      :data="rows"
      @sort-change="doChangeSort"
      ref="table"
      row-key="id"
      v-loading="loading"
    >
      <el-table-column type="selection" width="55"></el-table-column>

      <el-table-column v-if="hasPermissionToAuditLogs" :label="fields.id.label"  :prop="fields.id.name" sortable="custom">
        <template slot-scope="scope">{{ presenter(scope.row, 'id') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.logo.label"
        :prop="fields.logo.name"
        align="center"
      >
        <template slot-scope="scope">
          <app-list-item-image :value="presenter(scope.row, 'logo')"></app-list-item-image>
        </template>
      </el-table-column>

      <el-table-column
        :label="fields.theme.label"
        :prop="fields.theme.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'theme') }}</template>
      </el-table-column>

      <el-table-column
        :label="fields.createdAt.label"
        :prop="fields.createdAt.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'createdAt') }}</template>
      </el-table-column>

      <el-table-column :fixed="isMobile? undefined : 'right'" align="center" width="180">
        <template slot-scope="scope">
          <div class="table-actions">
            <router-link :to="`/property-setting/${scope.row.id}`">
              <el-button type="text">
                <app-i18n code="common.view"></app-i18n>
              </el-button>
            </router-link>

            <router-link :to="`/property-setting/${scope.row.id}/edit`" v-if="hasPermissionToEdit">
              <el-button type="text">
                <app-i18n code="common.edit"></app-i18n>
              </el-button>
            </router-link>

            <el-button
              :disabled="destroyLoading"
              @click="doDestroyWithConfirm(scope.row.id)"
              type="text"
              v-if="hasPermissionToDestroy"
            >
              <app-i18n code="common.destroy"></app-i18n>
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="el-pagination-wrapper">
      <el-pagination
        :current-page="pagination.currentPage || 1"
        :disabled="loading"
        :layout="paginationLayout"
        :total="count"
        @current-change="doChangePaginationCurrentPage"
        @size-change="doChangePaginationPageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { PropertySettingModel } from '@modules/property-setting/property-setting-model';
import { mapGetters, mapActions } from 'vuex';
import { PropertySettingPermissions } from '@modules/property-setting/property-setting-permissions';
import { i18n } from '@shared/i18n';

const { fields } = PropertySettingModel;

export default {
  name: 'app-property-setting-list-table',

  mounted() {
    this.doMountTable(this.$refs.table);
  },

  computed: {
    ...mapGetters({
      rows: 'propertySetting/list/rows',
      count: 'propertySetting/list/count',
      loading: 'propertySetting/list/loading',
      pagination: 'propertySetting/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'propertySetting/destroy/loading',
      paginationLayout: 'layout/paginationLayout',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new PropertySettingPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new PropertySettingPermissions(this.currentUser).destroy;
    },

    fields() {
      return fields;
    },
  },

  methods: {
    ...mapActions({
      doChangeSort: 'propertySetting/list/doChangeSort',
      doChangePaginationCurrentPage:
        'propertySetting/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'propertySetting/list/doChangePaginationPageSize',
      doMountTable: 'propertySetting/list/doMountTable',
      doDestroy: 'propertySetting/destroy/doDestroy',
    }),

    presenter(row, fieldName) {
      return PropertySettingModel.presenter(row, fieldName);
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy(id);
      } catch (error) {
        // no
      }
    },
  },
};
</script>

<style>
</style>
